import React, { useId } from "react"

import {
  Container,
  StyledCard,
  ImageRegular,
  ImageCropped,
  HeadlineWord,
  NavigationHeadline,
} from "./styles"

const NavigationCard = ({ headline, imageUrl, imageCrops, ...props }) => {
  const mediaWidthDesktop = 239
  const mediaHeightDesktop = 184
  const mediaWidthMobile = 200
  const mediaHeightMobile = 154
  const baseId = useId()

  const renderHeadline = (text) => {
    if (!text) return null

    const BASE_CHAR_LIMIT = 12
    const words = text.trim().split(/\s+/).reverse()

    const getEffectiveLength = (str) => {
      const punctuationCount = (str.match(/[.,]/g) || []).length
      return str.length - punctuationCount * 0.5
    }

    const lines = []
    let currentLine = words[0]

    for (let i = 1; i < words.length; i += 1) {
      const word = words[i]
      const combinedLine = `${word} ${currentLine}`

      if (getEffectiveLength(combinedLine) <= BASE_CHAR_LIMIT) {
        currentLine = combinedLine
      } else {
        lines.push(currentLine)
        currentLine = word
      }
    }

    lines.push(currentLine)

    return lines
      .reverse()
      .map((line) => <HeadlineWord key={`${baseId}-line`}>{line.trim()}</HeadlineWord>)
  }

  const imageElement = imageUrl ? (
    <ImageRegular
      variant="4col"
      baseUrl={imageUrl}
      alt={headline}
      images={[
        {
          screenSize: 576,
          transforms: `c_fit,w_${mediaWidthDesktop},h_${mediaHeightDesktop},q_auto,fl_lossy,f_auto`,
        },
        {
          transforms: `c_fill,g_auto,w_${mediaWidthMobile},h_${mediaHeightMobile},q_auto,f_auto,fl_lossy`,
        },
      ]}
      isGrid
      imagePosition="top"
    />
  ) : imageCrops ? (
    <ImageCropped
      variant="4col"
      imageData={imageCrops}
      alt={headline}
      sizes={[
        {
          query: 576,
          width: mediaWidth,
          height: mediaHeight,
          transforms: `c_fill,g_auto,w_${mediaWidthDesktop},h_${mediaHeightDesktop},q_auto,f_auto,fl_lossy`,
        },
        {
          query: 0,
          width: mediaWidth,
          height: mediaHeight,
          transforms: `c_fill,g_auto,w_${mediaWidthMobile},h_${mediaHeightMobile},q_auto,f_auto,fl_lossy`,
        },
      ]}
      isGrid
      imagePosition="top"
    />
  ) : null

  return (
    <Container>
      <StyledCard
        {...props}
        headline={headline}
        headlineOverride={
          <NavigationHeadline variant="medium">{renderHeadline(headline)}</NavigationHeadline>
        }
        imageOverride={imageElement}
      />
    </Container>
  )
}

export default NavigationCard
